import { CIcon } from '~/icons/types'

export const ciBoatRow: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M23.959 6.354a.5.5 0 0 0-.623-.333l-4.98 1.512a11.61 11.61 0 0 1-3.369.49l-2.5-.017 1.043-1.043a.5.5 0 1 0-.707-.707l-1.741 1.741-10.581-.07a.5.5 0 0 0 0 1h.657l.591 3.815A2.019 2.019 0 0 0 2.963 14.3l-.61.38a1.461 1.461 0 0 0-.26 2.26l.76.76a1.444 1.444 0 0 0 1.19.41 1.44 1.44 0 0 0 1.06-.67l.94-1.51a.971.971 0 0 0-.14-1.22l-.059-.058.174-.174 11.734.078h.02a3.1 3.1 0 0 0 2.807-1.914l.424-.935.011-.025 2.056-4.537.563-.17a.5.5 0 0 0 .326-.62ZM2.57 11.544l2.744.015a.5.5 0 0 0 0-1l-2.9-.015-.249-1.606 7.923.052L5.6 13.48l-1.855-.017a1.027 1.027 0 0 1-1.013-.873l-.162-1.046Zm1.686 5.37a.46.46 0 0 1-.711.08l-.75-.76a.42.42 0 0 1-.129-.37.459.459 0 0 1 .21-.33l1.49-.94.4.4.009.01.4.39-.919 1.52Zm15.965-5.916-8.231-.068a.5.5 0 0 0 0 1l7.783.064-.108.24a2.118 2.118 0 0 1-1.9 1.326h-.014l-10.746-.07L11.494 9l3.486.023h.081c1.215 0 2.423-.18 3.585-.533l3.144-.955-1.569 3.463Z',
      fill: 'currentColor'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'boat-row',
  type: 'thin'
}
